exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-avatar {\n  width: 32px;\n  height: 32px;\n}\n.vue-avatar img {\n  border-radius: 32px;\n  background-color: #f0f0f0;\n}\n", ""]);

// exports
